export const isJwtExpiringSoon = (token: string, bufferInSeconds = 30): boolean => {
  try {
    const base64Url = token.split('.')[1];

    if (!base64Url) return true;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((char) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    const payload = JSON.parse(jsonPayload);

    if (!payload.exp) return true;

    const expiryTime = payload.exp * 1000; // JWT exp → ms
    const currentTime = Date.now();
    const bufferTime = bufferInSeconds * 1000;

    // true if token expires within next buffer seconds (default 10 seconds)
    return expiryTime <= currentTime + bufferTime;
  } catch {
    return true;
  }
};
